import React, { type ReactElement, useMemo } from 'react'
import { type SerializedStyles, css } from '@emotion/react'
import { type TestID } from '../../../utils/testing/types'
import { gridBodyRowStyles } from '../utils/grid.styles'
import { type GridDatum, type GridRow } from '../utils/grid.types'
import { GridBodyCell } from './GridBodyCell'

interface Props<TData extends GridDatum> extends GridRow<TData>, TestID {}

export const GridBodyRow = <TDatum extends GridDatum>({
  'data-testid': testId,
  cells,
  getRowProps,
}: Props<TDatum>): ReactElement => {
  const renderedCells = useMemo(
    () => cells.map(cell => <GridBodyCell key={`${cell.row.id}-${cell.column.id}`} {...cell} />),
    [cells]
  )

  const { style, ...rowProps } = getRowProps()
  const dynamicStyles = css(style as SerializedStyles, gridBodyRowStyles)

  return (
    <div {...rowProps} css={dynamicStyles} data-testid={testId}>
      {renderedCells}
    </div>
  )
}
